import { AddressFormState } from '../../../components/ShippingAddress/hooks/useHandleFormInput';

type Prospect = {
  address: AddressFormState;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  password: string;
  email: string;
};

type CampaignInfo = {
  campaignId: number;
  campaignName: string;
};

export type State = {
  id: number;
  countryId: number;
  stateCode: string;
  displayName: string
};

export type Labels = {
  locale: string;
  shipping_equivalent: string;
  zip_code: string;
};

type Country = {
  id: number;
  countryCode: string;
  displayName: string;
  flagUrl: string | null;
  phoneFormat: string;
  hasGdpr: boolean;
  hasStates: boolean;
  active: boolean;
  labels: Labels;
  states: State[];
};

type ExperienceFlow = 'publicShop' | 'gtb';

const createEmptyProspect = (): Prospect => (
  {
    address: {
      shipAddress1: '',
      shipAddress2: '',
      shipCity: '',
      shipCountry: '',
      shipState: '',
      shipZipCode: '',
    },
    firstName: '',
    lastName: '',
    phoneNumber: '',
    password: '',
    email: '',
  }
);

const createEmptyCampaignInfo = (): CampaignInfo => ({
  campaignId: 0,
  campaignName: '',
});

export type {
  Prospect,
  CampaignInfo,
  Country,
  ExperienceFlow,
};
export { createEmptyProspect, createEmptyCampaignInfo };
